import { addDays, format, isWeekend, parseISO } from 'date-fns'
import { nl } from 'date-fns/locale'

/**
 * Aaneengesloten vakantiereeks rond een dag. Weekenden worden overbrugd (die krijgen
 * bij het markeren geen eigen uitzondering), maar niet meegeteld. Buiten het venster
 * from..to stopt het zoeken, zodat de getoonde periode klopt met de opgehaalde data.
 */
export function vacationRange(vacationDates: Set<string>, day: string, from: string, to: string): string[] {
  if (!vacationDates.has(day)) return []

  const found = [day]

  for (const direction of [-1, 1]) {
    let cursor = addDays(parseISO(day), direction)
    while (true) {
      const iso = format(cursor, 'yyyy-MM-dd')
      if (iso < from || iso > to) break
      if (vacationDates.has(iso)) found.push(iso)
      else if (!isWeekend(cursor)) break
      cursor = addDays(cursor, direction)
    }
  }

  return found.sort()
}

export function periodLabel(dates: string[]): string {
  const start = parseISO(dates[0])
  const end = parseISO(dates[dates.length - 1])
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()
  const startLabel = sameMonth ? format(start, 'd', { locale: nl }) : format(start, 'd MMM', { locale: nl })
  return `${startLabel} t/m ${format(end, 'd MMM', { locale: nl })}`
}
